import React, { createContext } from 'react';
import useStockCar from '../../hooks/useStockCar';
import type { VehicleBag } from '../../types';

interface VehicleProviderProps {
  children: React.ReactNode;
  isTier3: boolean;
  isMock: boolean;
}
const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
const vehicleId = new URLSearchParams(locationSearch).get('vehicleId');
const market = new URLSearchParams(locationSearch).get('market');

// This is injected to the application at root level, context will always have a value
export const vehicleContext = createContext<VehicleBag>({} as VehicleBag);
const { Provider } = vehicleContext;

const VehicleProvider: React.FC<VehicleProviderProps> = ({ children, isTier3, isMock }) => {
  const vehicleBag = useStockCar({ vehicleId, market, isTier3, isMock });

  return <Provider value={vehicleBag}>{children}</Provider>;
};

export default VehicleProvider;
